module.exports = {"530113001":"铜都街道","530113002":"碧谷街道","530113102":"汤丹镇","530113103":"因民镇","530113104":"阿旺镇","530113105":"乌龙镇","530113106":"红土地镇","530113107":"拖布卡镇","530113201":"舍块乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530113.json
// module id = 2676
// module chunks = 0